import { useMemo } from 'react';

export function useGridHeight(rowCount, {
  row = 52,     // MUI default row height ~52
  header = 56,  // header height
  footer = 52,  // footer/pagination
  max = 600     // cap so it doesn't explode on long lists
} = {}) {
  return useMemo(() => {
    const h = header + rowCount * row + footer;
    return Math.min(h, max);
  }, [rowCount, row, header, footer, max]);
}